var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFreeprisoners(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M315.4 20.34L228 70.5l146-32.28zM67.73 23l-24 16H212.3l-24-16zM73 57v30h16V57zm34 0v30h42V57zm60 0v30h16V57zm73.4 33.86l175.1 41.54-39.9-40.56zM57 105v16h142v-16zm169.1 7.9l50.1 57.8 49.5-3.2zM105 139v44h46v-44zm-89 59v33h480v-33zm0 51v247h36.68l11.99-10.8-25.34-28.1 40.21 14.8 15.27-13.7-14.04-16.5L107.5 413l-11.55-20.8-30.81-27.5 32.17 5.1 49.49-17.2-17.9-32.6 27.6 15.7 9.6-22.5 10.5 45.1 43.2 38.1-16.1 26.5 8.7 8.7 40.7-4.4-25.1 19.9 12.9 12.8-20.1 36.1h177.5l12.5-33.1-36.6-18.1c-14 12.8-24.1 28.3-44 36.9l-41.3-35 11.6-13.8 29.7 25.2c21.9-24 30-38.3 43.2-69.3l-17.4-4.6-30.4 21.6-.9-17.4 28.6-19.3 32.6.9c-4.6-7.3-5.9-17-3.5-26.2 3.8-14.9 16.2-25.2 29.2-24.5 1.5.1 3 .3 4.4.7 14.2 3.7 22.2 20.3 17.9 37.1-3.2 12.4-12.3 21.9-23.2 24.1l20.1 17.8 23.5-13.7 12.5 11.2-38.1 20.9-20.7-17.9-12.5 33 38.7 22-16.5 41.5H496V249z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreeprisoners);
export default __webpack_public_path__ + "static/media/freeprisoners.3236ee9723e69ce915df5bd0dcc73504.svg";
export { ForwardRef as ReactComponent };